import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getLanguageDirection, LANGUAGE_STORAGE_KEY } from ".";

function LocaleProvider({ children }) {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language || "en";
  const normalizedLanguage = language.startsWith("ar") ? "ar" : "en";
  const direction = getLanguageDirection(normalizedLanguage);

  useEffect(() => {
    document.documentElement.lang = normalizedLanguage;
    document.documentElement.dir = direction;
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
  }, [direction, normalizedLanguage]);

  return children;
}

export default LocaleProvider;
